import type { IntlShape } from 'react-intl'
import type { TrendingDestination } from '../TrendingDestinations/constants'
import formatStaticAppText from 'lib/format/formatStaticAppText'
import { buildHotelUrl } from '../TrendingDestinations/utils'

export type TrendingDestinationWithId = TrendingDestination & { destinationId: string }

export type LocalDestinationOfferCarouselFilterOption = {
  value: string
  label: string
}

export type LocalDestinationOfferCarouselViewModel = {
  destinations: Array<TrendingDestinationWithId>
  destinationFilterOptions: Array<LocalDestinationOfferCarouselFilterOption>
  defaultDestinationId: string | undefined
}

export function getTrendingDestinationsWithIds(
  trendingDestinations: Array<TrendingDestination>,
): Array<TrendingDestinationWithId> {
  return trendingDestinations.filter(
    (destination): destination is TrendingDestinationWithId => !!destination.destinationId,
  )
}

export function mapDestinationsToFilterOptions(
  intl: IntlShape,
  destinations: Array<TrendingDestinationWithId>,
): Array<LocalDestinationOfferCarouselFilterOption> {
  return destinations.map(destination => ({
    value: destination.destinationId,
    label: formatStaticAppText(intl, destination.name),
  }))
}

export function buildLocalDestinationOfferCarouselViewModel(
  intl: IntlShape,
  trendingDestinations: Array<TrendingDestination>,
  frozenDefaultDestinationId?: string,
): LocalDestinationOfferCarouselViewModel {
  const destinations = getTrendingDestinationsWithIds(trendingDestinations)
  const destinationFilterOptions = mapDestinationsToFilterOptions(intl, destinations)
  const defaultDestinationId = resolveFrozenLocalDestinationDefaultFilter(
    frozenDefaultDestinationId,
    destinationFilterOptions,
  )

  return {
    destinations,
    destinationFilterOptions,
    defaultDestinationId,
  }
}

export function buildLocalDestinationViewAllUrl(
  destinations: Array<TrendingDestinationWithId>,
  selectedDestinationId?: string,
): string | undefined {
  const destination = destinations.find(item => item.destinationId === selectedDestinationId)
  if (!destination?.destinationId) {
    return undefined
  }
  return buildHotelUrl(destination.name, destination.destinationId)
}

export function resolveFrozenLocalDestinationDefaultFilter(
  frozenDefaultFilter: string | undefined,
  filterOptions: Array<{ value: string }>,
): string | undefined {
  if (
    frozenDefaultFilter !== undefined
    && filterOptions.some(option => option.value === frozenDefaultFilter)
  ) {
    return frozenDefaultFilter
  }

  return filterOptions[0]?.value
}
